import { AppLayout } from '@/components/app-layout';
import { AppSumoGate } from '@/components/appsumo-gate.component';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { CompanyDetailContainer } from '@/containers/companies/company-detail.component';
import { recordDetailSearch } from '@/containers/people/record-return.util';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/companies/$companyId/')({
  component: RouteComponent,
  validateSearch: recordDetailSearch,
});

function RouteComponent() {
  const { returnTo } = Route.useSearch();
  return (
    <>
      <Head heading='Company Detail' />
      <AuthCheck>
        <OnboardingCheck>
          <AppLayout variant='full-bleed'>
            <AppSumoGate label='Companies'>
              <CompanyDetailContainer returnTo={returnTo} />
            </AppSumoGate>
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
